import React, { useEffect, useState } from "react";
import { createTheme } from "react-data-table-component";
import { Bar } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
import Title from "../../components/title";
import { useLocation } from "react-router";
import { arrayBases } from "../../util/loja";
import queryString from "query-string";

import { PermissionsPage } from "../../util/permissionsPage";
import { useUserData } from "../../hooks/useUserData";
import {
  Box,
  Paper,
  Skeleton,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { SelectFilterMonth } from "../../components/FilterLojaMetas/SelectMes";
import { SelectLoja } from "../../components/FilterLojaMetas/SelectLoja";
import { isEmptyObject } from "../../util/isEmptyObject";
import ErrorToastHandler from "../../util/ErrorToastHandler";
import { ListSeller } from "../../components/componentsMetaVendedor/ListSeller/ListSeller";
import { dataChart, optionsChartBar } from "../../dataCharts/metas-vendedor";
import { SelectBases } from "../../components/SelectBases/SelectBases";
import { formatShopAvailable } from "../../formatdata/formatter-shop-available";
import { storageStoresGet } from "../../storage/storageStores";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
import metasVendedorPeriodo from "../../services/metasVendedorPeriodo";
import { crmGestanteService } from "../../services/crmGestante";
import { DatePikerFilter } from "../../components/DatePikerFilterV2";
import metas from "../../services/metas";


createTheme("solarized", {
  divider: {
    default: "transparent",
  },
});

function compararPorMetaRealizada(a, b) {
  if (a.metaRealizada < b.metaRealizada) {
    return 1;
  } else if (a.metaRealizada > b.metaRealizada) {
    return -1;
  } else {
    return 0;
  }
}

const defaultValues = {
  base: null,
  periodo: null,
  first_period: null,
  final_period: null,
};
function MetasVendedorPeriodo() {
  const theme = useTheme();
  const [paramsConfig, setParamsConfig] = useState(defaultValues);
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));
  const [availableStore, setAvailableStore] = useState([]);
  const [storesSelect, setStoreSelect] = useState(null);
  const [dataBackup, setDataBackup] = useState({});
  const [periodosDisponiveis, setPeriodosDisponiveis] = useState([]);
  const [basesDisponiveis, setBasesDisponiveis] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [dataPage, setDataPage] = useState([]);

  const history = useHistory();

  const { search } = useLocation();
  const { userData } = useUserData();

  const storeId = new URLSearchParams(search).get("loja")
    ? new URLSearchParams(search).get("loja")
    : false;
  const isApp = new URLSearchParams(search).get("app")
    ? new URLSearchParams(search).get("app")
    : false;

  function selecionarPeriodo(value) {
    console.log(value);

    if (value) {
      setParamsConfig((old) => ({
        ...old,
        periodo: value,
      }));
    }
  }

  const getElementAtEvent = (element) => {
    if (!element.length) return;
  };

  const getDataPage = async () => {
    try {
      setIsLoading(true);
      const [metasRes, gestanteRes] = await Promise.allSettled([
        metasVendedorPeriodo.get({
          ...paramsConfig,
          periodoInputFim: paramsConfig.final_period,
          periodoInputInicio: paramsConfig.first_period,
        }),
        crmGestanteService.relatorioDesempenho({
          startDate: paramsConfig.first_period,
          finalDate: paramsConfig.final_period,
          bases: [paramsConfig.base],
        }),
      ]);

      if (metasRes.status === "rejected") throw metasRes.reason;
      const response = metasRes.value;

      const porVendedora =
        gestanteRes.status === "fulfilled"
          ? gestanteRes.value?.data?.porVendedora ?? []
          : [];
      const gestanteMap = new Map(porVendedora.map((v) => [v.codFunc, v]));

      const enrich = (arr) =>
        arr.map((s) => {
          const g = gestanteMap.get(s.codFunc);
          return {
            ...s,
            gestanteContatos: g?.totalContatos ?? 0,
            gestanteConversoes: g?.conversoes ?? 0,
            gestanteTaxaConversao: g?.taxaConversao ?? 0,
          };
        });

      const metasEnriquecidas = Object.fromEntries(
        Object.entries(response.data?.metas ?? {}).map(([k, v]) => [
          k,
          enrich(v),
        ])
      );

      setDataBackup(metasEnriquecidas);
      setDataPage(
        metasEnriquecidas[storesSelect?.value].sort(compararPorMetaRealizada)
      );
    } catch (error) {
      new ErrorToastHandler(error).showErrorToast();
    } finally {
      setIsLoading(false);
    }
  };

  const getAvailablePeriods = async () => {
    try {
      const response = await metas.getAvailablePeriods();
      return response.data;
    } catch (error) {
      new ErrorToastHandler(error).showErrorToast();
    }
  };

  const getAvailableStoresAndBases = async (periodId) => {
    try {
      const response = await metas.getAvailableStoresAndBases(periodId);
      return response.data
    } catch (error) {
      new ErrorToastHandler(error).showErrorToast();
    }
  };

  const filterAvailableStores = (value) => {
    console.log({ value, availableStore });

    const stores = availableStore.filter((item) => item.base === value);
    return stores
  };

  const onChangeParamsConfigBase = (value) => {

    const stores = filterAvailableStores(value);
    setStoreSelect({
      value: stores[0].value,
      label: stores[0].label,
    });
    setParamsConfig((old) => ({
      ...old,
      base: value,
    }));
  };

  const onChangeLojas = (data) => {
    setStoreSelect(data);
    Object.keys(dataBackup).forEach((key) => {
      if (+key === data.value) {
        setDataPage(dataBackup[key].sort(compararPorMetaRealizada));
      }
    });
  };

  const onChangeDatePicker = (value) => {
    setParamsConfig((old) => ({
      ...old,
      ...value,
    }));
  };

  const getInfoInitialDataPage = async () => {
    const periods = await getAvailablePeriods();
    setPeriodosDisponiveis(periods);
    const baseStoreResponse = await getAvailableStoresAndBases(periods[0]?.targetId);

    setBasesDisponiveis(baseStoreResponse?.bases || []);
    const stores = baseStoreResponse.lojas.filter((item) => item.base === baseStoreResponse?.bases[0]?.codBase);

    setStoreSelect({
      value: stores[0].id,
      label: `${stores[0].id} ${stores[0].sigla}`,
    });
    setAvailableStore(baseStoreResponse?.lojas);

    if (!!storeId) {
      const allShop = storageStoresGet();

      const shopCurrency = allShop.find((item) => +item.id === +storeId);

      if (!userData.nivelAcesso.find((item) => item === +storeId)) {
        toast.error("Você não possui permissão para acessar essa Loja");
        history.goBack();
        return;
      }
      if (shopCurrency) {
        setStoreSelect({
          value: shopCurrency.id,
          label: `${shopCurrency.id} ${shopCurrency.sigla}`,
        });
        setParamsConfig((old) => ({
          ...old,
          periodo: periods.data[0]?.id,
          base: shopCurrency.base,
        }));
        const newSearch = queryString.stringify({});
        history.replace({ search: newSearch });
      }
    } else {
      setStoreSelect({
        value: baseStoreResponse?.lojas[0].value,
        label: baseStoreResponse?.lojas[0].label,
      })
      setParamsConfig((old) => ({
        ...old,
        periodo: periods[0]?.id,
        base: baseStoreResponse?.bases[0]?.codBase,
      }));
    }
  };

  useEffect(() => {
    const subscribe = async () => {
      if (!isEmptyObject(userData)) {
        getInfoInitialDataPage();
      }
    };
    subscribe();
  }, [userData]);

  useEffect(() => {
    if (
      !isEmptyObject(userData) &&
      !!paramsConfig.base &&
      !!paramsConfig.periodo
    ) {
      getDataPage();
    }
  }, [userData, paramsConfig]);

  return (
    <>
      {PermissionsPage("metasVendasVendedorSemanal") && (
        <>
          {!isApp && <Title title="META SEMANAL POR VENDEDOR" />}
          {!isApp && (
            <Box
              pl={[0, 2]}
              display={"flex"}
              flexDirection={["column", "row"]}
              width={"100%"}
            >
              <Box
                width={["100%", "auto"]}
                display={["flex", "block"]}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <DatePikerFilter
                  paramsConfig={paramsConfig}
                  onChange={onChangeDatePicker}
                  isLoading={isLoading}
                />
              </Box>
              <Box width={"100%"} px={2}>
                <SelectBases
                  basesDisponiveis={basesDisponiveis}
                  onChange={onChangeParamsConfigBase}
                  paramsConfig={paramsConfig}
                  isLoading={isLoading}
                />

                <SelectLoja
                  options={availableStore.filter(item => item.base === paramsConfig.base)}
                  isDisabled={isLoading}
                  onChange={onChangeLojas}
                  value={storesSelect}
                  label="Loja"
                />

                <Box mt={1} width={"100%"}>
                  <SelectFilterMonth
                    isDisabled={isLoading}
                    periodoReferencia={paramsConfig.periodo}
                    periodosDisponiveis={periodosDisponiveis}
                    selecionarPeriodo={selecionarPeriodo}
                  />
                </Box>
              </Box>
            </Box>
          )}
          <>
            <Stack
              alignItems={"center"}
              justifyContent={"center"}
              m={2}
              overflow={"hidden"}
            >
              {!isLoading ? (
                <Box
                  my={[2, 0]}
                  pt={2}
                  maxWidth={"80vw"}
                  sx={{ overflowX: ["scroll", "auto"] }}
                  height={["auto"]}
                  component={Paper}
                  variant="outlined"
                  elevation={isSm ? 2 : 0}
                >
                  <Bar
                    height={!isApp || !isSm ? 500 : undefined}
                    width={!isApp || !isSm ? 600 : undefined}
                    data={dataChart({
                      isApp: isApp || !isSm,
                      dataPage,
                    })}
                    options={optionsChartBar({
                      dataPage,
                      isApp: isApp || !isSm,
                    })}
                    getElementAtEvent={getElementAtEvent}
                    redraw
                  />
                </Box>
              ) : (
                <Skeleton variant="rounded" width={600} height={500} />
              )}
            </Stack>
            <ListSeller dataPage={dataPage} isLoading={isLoading} />
          </>
        </>
      )}
    </>
  );
}

export default MetasVendedorPeriodo;
